import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Button } from './ui/button';
import { LogOutIcon, UserCircle2 } from 'lucide-react';
import { useLoginQuery } from '@/hooks/queries/useLoginQuery';

interface DashboardLayoutProps {
  children: ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const { data: loginData } = useLoginQuery();
  const loginUser = loginData;
  const userName = loginUser?.firstName;


  return (
    <div className="flex min-h-screen">
      <Sidebar />

      <main className="flex-1 overflow-y-auto" data-dashboard-scroll-root>
        <div className="w-full border-b bg-card">
          <div className="flex items-center justify-end gap-4 p-3">
            <div className="flex items-center gap-3   px-4 py-2 ">
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-orange-300 text-slate-900">
                <UserCircle2 className="h-5 w-5" />
              </div>
              <p className="text-xs font-semibold uppercase tracking-wide text-slate-700">
                {userName}
              </p>
            </div>
            <Button asChild variant="outline" className="gap-2">
              <Link to="/logout">
                <LogOutIcon className="h-4 w-4" />
                Logout
              </Link>
            </Button>
          </div>
        </div>
        <div className="p-8  w-full">
          {children}
        </div>
      </main>
    </div>
  );
}
